import type { ReactNode } from 'react';
import { SheetContent } from '@/components/atoms/sheet';
import { cn } from '@/lib/utils';
import { DataTableDrawerActionFooter } from './DataTableDrawerActionFooter';
import { DataTableDrawerApplyFooter } from './DataTableDrawerApplyFooter';
import { DataTableDrawerHeader } from './DataTableDrawerHeader';

interface DataTableDrawerSheetProps {
  title: string;
  onClose: () => void;
  onReset?: () => void;
  resetDisabled?: boolean;
  onApply?: () => void;
  footer?: 'actions' | 'apply' | ReactNode;
  children: ReactNode;
  contentClassName?: string;
  bodyClassName?: string;
  scrollBody?: boolean;
}

export function DataTableDrawerSheet({
  title,
  onClose,
  onReset,
  resetDisabled = false,
  onApply,
  footer,
  children,
  contentClassName,
  bodyClassName,
  scrollBody = true,
}: DataTableDrawerSheetProps) {
  const content = scrollBody ? (
    <div className="flex-1 overflow-y-auto">
      <div className={cn('px-5', bodyClassName)}>{children}</div>
    </div>
  ) : (
    children
  );

  return (
    <SheetContent
      side="right"
      className={cn('flex w-80 flex-col gap-0 p-0', contentClassName)}
      showCloseButton={false}
    >
      <DataTableDrawerHeader
        title={title}
        onClose={onClose}
        onReset={onReset}
        resetDisabled={resetDisabled}
      />
      {content}
      {footer === 'actions' ? (
        <DataTableDrawerActionFooter
          onReset={onReset ?? (() => undefined)}
          onApply={onApply ?? onClose}
          resetDisabled={resetDisabled}
        />
      ) : footer === 'apply' ? (
        <DataTableDrawerApplyFooter onApply={onApply ?? onClose} />
      ) : (
        footer
      )}
    </SheetContent>
  );
}
